/* eslint-disable no-shadow */
import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { fetchUpgradePopup } from '../../../actions/upgrade-to-power-actions';

import PowerEventUpgradeContent from './PowerEventUpgradeContent';

const PowerEventUpgrade = props => {
    const { auth, referral, fetchUpgradePopup, upgradePopup } = props;
    const { user } = auth;

    useEffect(() => {
        fetchUpgradePopup('power');
    }, []);

    return (
        <PowerEventUpgradeContent
            isLoading={upgradePopup.isLoading}
            data={upgradePopup.data}
            onClick={props.onClick}
            user={user}
            referral={referral}
        />
    );
};

const mapStateToProps = ({ auth, upgradePopup }) => {
    return { auth, upgradePopup };
};

const mapDispatchToProps = dispatch => {
    return {
        fetchUpgradePopup: (prismicUid) => dispatch(fetchUpgradePopup(prismicUid)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PowerEventUpgrade);
